// Master list of all supported features and their display labels
export const FEATURE_LABELS = {
  // Common architectural features
  arch: 'Arch',
  ashlarWall: 'Ashlar Wall',
  bevelBlock: 'Bevel Block',
  column: 'Column',
  niche: 'Niche',
  polygonalMasonry: 'Polygonal Masonry',
  polygonalWall: 'Polygonal Wall',
  pyramid: 'Pyramid',
  terraces: 'Terraces',

  // Construction and tool marks
  clamps: 'Clamps',
  damageHoles: 'Damage Holes',
  lippedBlocks: 'Lipped Blocks',
  nubs: 'Nubs/Protrusions',
  pinchMark: 'Pinch Mark',
  sawCuts: 'Saw Cuts', 
  scoopMarks: 'Scoop Marks',
  scrapeMarks: 'Scrape Marks',
  wedgeHoles: 'Wedge Holes',

  // Cultural and religious features
  hananPacha: 'Hanan Pacha',
  hinduTemple: 'Hindu Temple',
  lingam: 'Lingam',
  sarcophagus: 'Sarcophagus',
  statues: 'Statues',

  // Natural and environmental features 
  acousticProperties: 'Acoustic Properties',
  astronomicalAlignments: 'Astronomical Alignments',
  cave: 'Cave/Underground',
  cartRuts: 'Cart Ruts',
  vitrification: 'Vitrification',
  waterFeatures: 'Water Features',

  // Artistic and decorative features
  inscriptions: 'Inscriptions',
  murals: 'Murals',
  stairstepmotif: 'Stairstep Motif'
};